/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CompletePlasmaFlowRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'
import {CompletePlasmaFlowResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/utility_messages.pb'


export const completePlasmaFlow = (request:CompletePlasmaFlowRequest, options?: CashRequestOptions) => post<CompletePlasmaFlowRequest, CompletePlasmaFlowResponse>("/2.0/cash/complete-plasma-flow", request, {...options, rejectOnError: true })